<template>
  <header id="header" class="sticky top-0 bg-white shadow-md py-1 md:py-2 px-2 lg:px-4 z-10 print:static">
    <div class="flex justify-between items-center mx-auto max-w-6xl">
      <div class="lg:px-2">
        <h1 class="text-xl md:text-2xl lg:text-3xl font-bold text-red-600 print:text-black truncate max-w-site-title">
          <router-link to="/" @click.native="aclick">{{ header.title || 'grund_schule kunst bildung' }}</router-link>
        </h1>
      </div>
      <div class="print:hidden">
        <div class="text-4xl cursor-pointer">
          <button @click="menuOpen = !menuOpen" class="p-1 focus:outline-none">
            <menu-button :open="menuOpen"/>
          </button>
        </div>
      </div>
    </div>
    <div :style="menuHeight" class="absolute md:py-1 w-full left-0 bg-white overflow-y-auto overscroll-none duration-200 transition-all ease-in-out leading-snug px-2 lg:px-4">
      <div :class="{ hidden: !menuOpen }" class="mx-auto max-w-6xl py-6 md:py-12 lg:px-2 overflow-y-auto">
        <ul class="font-bold">
          <li v-for="link in header.menus.journal" :key="link.ID">
            <anchor-wrap :url="link.url" @click.native="aclick">{{ link.title }}</anchor-wrap>
          </li>
        </ul>
        <!-- <ul class="font-bold mt-4">
          <li v-for="link in header.menus.other" :key="link.ID">
            <anchor-wrap :url="link.url" @click.native="aclick">{{ link.title }}</anchor-wrap>
          </li>
        </ul> -->
        <ul class="font-bold mt-4">
          <li v-for="link in header.menus.infos" :key="link.ID">
            <anchor-wrap :url="link.url" @click.native="aclick">{{ link.title }}</anchor-wrap>
          </li>
        </ul>
        <ul class="font-bold mt-4">
          <li v-for="link in header.menus.kontakt" :key="link.ID">
            <anchor-wrap :url="link.url" @click.native="aclick">{{ link.title }}</anchor-wrap>
          </li>
        </ul>
        <ul class="font-bold mt-4">
          <li v-for="link in header.menus.external" :key="link.ID">
            <anchor-wrap :url="link.url" @click.native="aclick">{{ link.title }}</anchor-wrap>
          </li>
        </ul>

        <div class="mt-12 md:mt-24">
          <div v-html="header.info"></div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import AnchorWrap from '@/components/AnchorWrap'
  import MenuButton from '@/components/MenuButton'

  export default {
    name: 'AppHeader',
    data () {
      return {
        menuOpen: false
      }
    },
    computed: {
      header () {
        return this.$store.state.header
      },
      menuHeight () {
        return {
          height: this.menuOpen ? 'calc(100vh - 58px)' : '0'
        }
      }
    },
    methods: {
      setColors () {
        if ('categories' in this.header) {
          const el = document.documentElement
          let css = ''
          this.header.categories.forEach((c) => {
            if ('acf' in c) {
              css += `.text-${c.slug} {color:var(--text-${c.slug})}`
              css += `.bg-${c.slug},.hover\\:bg-${c.slug}:hover{background-color: var(--bg-${c.slug})}`
              el.style.setProperty(`--bg-${c.slug}`, c.acf.bg_color || 'white')
              el.style.setProperty(`--text-${c.slug}`, c.acf.color || '')
            }
          })
          const style = document.createElement('style')
          style.type = 'text/css'
          style.appendChild(document.createTextNode(css))
          document.head.appendChild(style)
        }
      },
      aclick ({ target }) {
        const href = target.getAttribute('href')
        if (href && this.$route.path === href) {
          this.menuOpen = false
        }
      }
    },
    mounted () {
      this.setColors()
    },
    watch: {
      '$route' (to, from) {
        this.menuOpen = false
      }
    },
    components: { AnchorWrap, MenuButton }
  }
</script>
